

























































































import { apiMallTopFrontCategoryList } from '@/api'
import { computed, ref } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useQuery } from '@/hooks'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: `三级分类-${this.query.name}`,
        }))
      }

      query = useQuery<{
        id: string
        name: string
      }>()

      loading = computed(() => false)

      filterIndex = ref(0)

      absFilterIndex = computed(() => Math.abs(this.filterIndex.value))

      handleDataLoad = ({ pageNumber }: any) => {
        return apiMallTopFrontCategoryList({
          pageIndex: pageNumber,
          pageSize: 10,
          categoryId: this.query.id,
          sortType:
            this.absFilterIndex.value === 1
              ? 2
              : this.absFilterIndex.value === 2
              ? 3
              : 1,
          asc: this.filterIndex.value > 0,
        })
      }

      toDetail = (url: any) => {
        dcb.navigateTo({ url })
      }
    },
)
